<template>
  <div id="password_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Update Password</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <span><i class="fa fa-envelope"></i> {{ formParam.email }}</span>
              <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>
                      New Password:
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="password"
                      class="form-control"
                      v-model="formParam.new_password"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-3"></div>
              </div>
            </div>
          </div>

          <div class="submit-section">
            <button
              @click.prevent="saveForm(1)"
              class="btn btn-primary submit-btn"
              type="button"
              :style="'margin-left:10px;'"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      isSending: false,
      formParam: {
        id: "",
        email: "",
        new_password: ""
      },
      isLoading: false
    };
  },
  watch: {
    isShowFormP: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            that.formParam = that.formParamStP;
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    formParamStP() {
      return this.$store.state.agent.formParamStP;
    },
    isShowFormP() {
      return this.$store.state.agent.isShowFormP;
    }
  },
  methods: {
    async saveForm(isExit = 0) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          await this.$store
            .dispatch("agent/updatePasswordStored", this.formParam)
            .then(response => {
              // this.isSending = false;
              this.formParam = {
                id: "",
                email: "",
                new_password: ""
              };

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
                this.formParam = {
                  id: "",
                  email: "",
                  new_password: ""
                };
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "add-edit-form"
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/agents/password.vue